module.exports = __webpack_public_path__ + "img/layout-10_2.1cd72f09.png";